/* eslint-disable import/no-unresolved */
import React from 'react';
import OptimizedImage from '../../../OptimizedImage';

const StepsHeader = () => {
  return (
    <div className="row justify-content-between">
      <div className="col-lg-6">
        <div className="subtitle without bigger">
          Our software development process
          <div className="extra">
            Over the years, we have mastered the perfect process for seamless
            cooperation between our customers’ teams. For us, understanding the
            business needs of a partner is the only sound approach to successful
            software solutions.
          </div>
        </div>
      </div>
      <div className="col-md-5 col-lg-5 d-flex justify-content-lg-center align-items-center">
        <OptimizedImage
          src="our-approach.png"
          alt="icon"
          className="d-none d-lg-block w-100"
        />
      </div>
    </div>
  );
};

export default StepsHeader;
